import { ExclamationCircleOutlined } from '@ant-design/icons';
import { List, Modal, Typography } from 'antd';
import React from 'react';

const { Text, Title } = Typography;

const KnownIssuesWarningModal = ({
  visible,
  onConfirm,
  onCancel,
  issues = [],
  title = 'Known Issues Warning',
  confirmText = 'Proceed Anyway',
  cancelText = 'Cancel',
  confirmLoading = false,
  description = 'This item has the following known issues. Are you sure you want to proceed?',
}) => {
  if (!issues || issues.length === 0) return null;

  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <ExclamationCircleOutlined style={{ color: '#faad14', fontSize: 18 }} />
          <Title level={4} style={{ margin: 0, color: '#faad14' }}>
            {title}
          </Title>
        </div>
      }
      open={visible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText={confirmText}
      cancelText={cancelText}
      confirmLoading={confirmLoading}
      okButtonProps={{
        type: 'primary',
        danger: true,
      }}
      cancelButtonProps={{
        type: 'default',
      }}
      width={600}
      maskClosable={false}
      destroyOnClose
    >
      <div style={{ marginBottom: 16 }}>
        <Text>{description}</Text>
      </div>

      <List
        size="small"
        bordered
        dataSource={issues}
        renderItem={(issue, index) => (
          <List.Item>
            <Text>
              <span style={{ fontWeight: 500, marginRight: 8 }}>{index + 1}.</span>
              {issue}
            </Text>
          </List.Item>
        )}
        style={{
          maxHeight: 300,
          overflow: 'auto',
          backgroundColor: '#fff7e6',
          borderColor: '#ffd591',
        }}
      />
    </Modal>
  );
};

export default KnownIssuesWarningModal;
